import { Col, message, Modal, Row, Tabs } from "antd";
import COLORS from "common/Colors";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import MinePerformance from "./MinePerformance";
import MyTeamPerformance from "./MyTeamPerformance";
import HRPerformance from "./HRPerformance";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import ViewKpi from "./ViewKpi";
import { EditOutlined, RightOutlined } from "@ant-design/icons";
import UserFloatingButton from "../UserFloatingButton";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";
import FloatingHistoryButton from "./FloatingHistoryButton";
import { getMenuList, getUserInfo, getUserRoleId } from "redux/selectors";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { ReactComponent as Trash } from "../../../assets/trashfull.svg";
import { ReactComponent as Edit } from "../../../assets/editpencil.svg";

const PerformanceWrap = styled.div`
  .text-bold {
    font-weight: 500;
  }
  .ant-tabs-nav {
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
    position: absolute;
    bottom: -1px !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }

  .ant-tabs-nav::before {
    border: none !important;
  }
  .ant-tabs-nav-list {
    border-bottom: 2px solid #80808033;
  }

  @media (min-width: 320px) and (max-width: 420px) {
    .ant-tabs-tab {
      margin: 0 !important;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      gap: 1rem;
    }
  }
`;

const Performance = () => {
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);

  const Menulist =
    menuList[userRoleId] || Object.values(menuList)[0] || menuList;
  const history = useHistory();
  const location = useLocation();
  const userInfo = useSelector(getUserInfo);
  const [tabId, setTabId] = useState("1");
  console.log("tabid-->", tabId);
  const [isViewKpi, setIsViewKpi] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [kpiDataList, setKpiDataList] = useState({});
  console.log("kpiDataList-->", kpiDataList);
  const [historyList, setHistoryList] = useState([]);
  const id = location.state?.id;

  console.log("ids-->", id);

  const onChange = (key) => {
    setTabId(key);
    console.log("Tab switched to:", key);
  };

  const isMine = Menulist?.find(
    (item) => item?.key === "myperformance" && item?.permission.view
  );

  const isMyteam = Menulist?.find(
    (item) => item?.key === "myteamperformance" && item?.permission.view
  );
  const isHR = Menulist?.find(
    (item) => item?.key === "hrperformance" && item?.permission.view
  );
  const items = [
    isMine && {
      key: "1",
      label: "Mine",
      children: (
        <>
          {
            <MinePerformance
              setIsViewKpi={setIsViewKpi}
              setKpiDataList={setKpiDataList}
              Menulist={Menulist}
            />
          }
        </>
      ),
    },
    isMyteam && {
      key: "2",
      label: "My Team",
      children: (
        <>
          {
            <MyTeamPerformance
              setIsViewKpi={setIsViewKpi}
              setKpiDataList={setKpiDataList}
              Menulist={Menulist}
            />
          }
        </>
      ),
    },
    isHR && {
      key: "3",
      label: "HR",
      children: (
        <>
          {
            <HRPerformance
              setIsViewKpi={setIsViewKpi}
              setKpiDataList={setKpiDataList}
              Menulist={Menulist}
            />
          }
        </>
      ),
    },
  ];

  const fetchHistoryData = async (kpiId) => {
    try {
      const { historyList, code } = await CALL_API(
        `performance/appraisalhisorty/${kpiId}`,
        "get"
      );
      if (code === STATUS_CODE.SUCCESS) {
        setHistoryList(historyList);
      } else {
        throw new Error(`Failed to fetch data: ${code}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchHistoryData(kpiDataList?.appraiseeuserid);
  }, [kpiDataList]);

  useEffect(() => {
    if (id) {
      setTabId(id);
    }
  }, [id]);

  const handleDelete = async (record) => {
    setDeleteLoading(true);
    try {
      const { code } = await CALL_API(`performance/KPI/${record.id}`, "delete");
      if (code === STATUS_CODE.SUCCESS) {
        setPopupOpen(true);
        setTimeout(() => {
          setKpiDataList({});
          setIsViewKpi(false);
          setPopupOpen(false);
        }, 2000);
      } else {
        message.error("Failed to delete");
      }
    } catch (error) {
      console.error("Delete error:", error);
      message.error("Failed to delete");
    } finally {
      setDeleteLoading(false);
    }
  };

  const keyName =
    tabId === "2"
      ? "myteamperformance"
      : tabId === "1"
      ? "myperformance"
      : "hrperformance";

  return (
    <PerformanceWrap>
      {!isViewKpi && (
        <>
          <h6>Performance</h6>
          <Tabs activeKey={tabId} items={items} onChange={onChange} />
        </>
      )}
      {isViewKpi && (
        <ViewKpi
          dataList={kpiDataList}
          headerContent={
            <>
              {tabId === "1" && (
                <>
                  <div className="breadcrumb">
                    <p
                      className="lite-text p-0 m-0"
                      onClick={() => {
                        setKpiDataList({});
                        setIsViewKpi(false);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Performance
                    </p>
                    &nbsp;
                    <RightOutlined className="mt-1" />
                    &nbsp;
                    <p className="m-0 p-0 text-bold">{kpiDataList?.title}</p>
                  </div>
                  <h6 className="mb-2">
                    Key Responsibilities for the upcoming appraisal
                  </h6>
                </>
              )}
              {(tabId === "3" || tabId === "2") && (
                <>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="breadcrumb">
                        <p
                          className="lite-text p-0 m-0"
                          onClick={() => {
                            setKpiDataList({});
                            setIsViewKpi(false);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Performance
                        </p>
                        &nbsp;
                        <RightOutlined className="mt-1" />
                        &nbsp;
                        <p className="m-0 p-0 text-bold">
                          {kpiDataList?.fullname} - {kpiDataList?.title}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center ">
                        {Menulist?.find(
                          (item) =>
                            item?.key === keyName && item?.permission.edit
                        ) &&
                          !kpiDataList?.attendedon && (
                            <Edit
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                history.push("add-edit-kpi", {
                                  data: kpiDataList,
                                });
                              }}
                            />
                          )}
                        {Menulist?.find(
                          (item) =>
                            item?.key === keyName && item?.permission.delete
                        ) &&
                          !kpiDataList?.attendedon && (
                            <Trash
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                Modal.confirm({
                                  title:
                                    "Are you sure you want to delete this KPI?",
                                  icon: null,
                                  centered: true,
                                  okText: "Yes",
                                  cancelText: "No",
                                  okButtonProps: { type: "primary" },
                                  onOk: () => handleDelete(kpiDataList),
                                });
                              }}
                            />
                          )}
                      </div>
                    </div>

                    <Row gutter={[16, 16]} style={{ marginRight: "0px" }}>
                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12} className="lite-text">
                            Name of the Employee
                          </Col>
                          <Col xs={24} md={12} className="text-bold">
                            {kpiDataList?.fullname || "-"}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12} className="lite-text">
                            Departments
                          </Col>
                          <Col xs={24} md={12} className="text-bold">
                            {kpiDataList?.departmentname || "-"}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12} className="lite-text">
                            Title
                          </Col>
                          <Col xs={24} md={12} className="text-bold">
                            {kpiDataList?.title || "-"}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12} className="lite-text">
                            KPI Template
                          </Col>
                          <Col xs={24} md={12} className="text-bold">
                            {kpiDataList?.templatename || "-"}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12} className="lite-text">
                            Hired Date
                          </Col>
                          <Col xs={24} md={12} className="text-bold">
                            {kpiDataList?.hireddate || "-"}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12} className="lite-text">
                            Type
                          </Col>
                          <Col xs={24} md={12} className="text-bold">
                            {kpiDataList?.type || "-"}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12} className="lite-text">
                            Start date to attend appraisal
                          </Col>
                          <Col xs={24} md={12} className="text-bold">
                            {dayjs(kpiDataList?.attendstartdate).format(
                              "DD-MM-YYYY"
                            ) || "-"}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <br />
                  <h6 className="mb-2">KPI for the year</h6>
                  <FloatingHistoryButton
                    historyList={historyList?.filter(
                      (item) => item?.kpiid === kpiDataList?.id
                    )}
                    currentUserEmail={userInfo?.userid}
                  />
                  {/* <UserFloatingButton /> */}
                </>
              )}
            </>
          }
        />
      )}
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type="success"
        message="Deleted"
      />
    </PerformanceWrap>
  );
};

export default Performance;
